<template>
  <v-container>
    <v-row>
      <v-col sm="10">
        <h4 class="white--text">Project Tags</h4>
      </v-col>
      <v-col sm="2">
        <div :class="{ paddingT10: tagToggle }" @click="tagToggle = !tagToggle">
          <v-icon
            class="cursorPointer"
            color="white"
            size="25"
            v-if="!tagToggle"
            :data-test-id="`${dataTestId}__open-icon`"
            >add</v-icon
          >
          <v-icon class="cursorPointer" color="white" size="25" v-if="tagToggle" :data-test-id="`${dataTestId}__close-icon`"
            >maximize</v-icon
          >
        </div>
      </v-col>
    </v-row>
    <transition name="slideUp">
      <v-row v-if="tagToggle">
        <v-col sm="12">
          <div class="tag-container">
            <Tag
              v-for="(item, index) in allTagsDisplay"
              v-model="allTagsDisplay[index]"
              :key="index"
              :selected="item.selected"
              :text="tagAndCount(item)"
              :showDelete="false"
              @onTagClick="handleTagClick"
              :data-test-id="`${dataTestId}__tag-list-item-${index+1}`"
            ></Tag>
            <span v-if="!allTagsDisplay.length">No tags for this project</span>
          </div>
        </v-col>
      </v-row>
    </transition>
    <x-dialog
      :confirmDialog="true"
      :dialogTitle="'Confirm?'"
      :dialogText="'This will clear any of your search results. Continue?'"
      :dialogState="confirmation"
      @dialogOpen="closeDialog()"
      :actions="{
        show: true,
        secondaryButtonFunction: closeDialog,
        primaryButtonFunction: viewProjectTagArchives,
        primaryButtonShow: true,
        secondaryButtonText: 'Cancel',
        primaryButtonText: 'Confirm',
      }"
      :data-test-id="`${dataTestId}__confirm-dialog`"
    />
  </v-container>
</template>

<script>
import Tag from '@/components/Common/DisplayTextTag';

export default {
  data() {
    return {
      tagToggle: true,
      confirmation: false,
      selectedTag: '',
      allTagsDisplay: [],
    };
  },
  props: {
    projectDetails: Object,
    allTags: Array,
    dataTestId: String
  },
  watch: {
    allTags: {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        const tagsInURL =
          (this.$route.params.tagname &&
            this.$route.params.tagname.split(',')) ||
          false;

        this.allTagsDisplay = this.allTags.map((tag) => {
          return {
            tag: tag.tag,
            count: tag.count,
            selected:
              tagsInURL && tagsInURL.indexOf(tag.tag) !== -1 ? true : false,
          };
        });
      },
      immediate: true,
    },
  },
  components: {
    Tag,
  },

  methods: {
    handleTagClick(tag) {
      let tags = this.$route.params.tagname
        ? this.$route.params.tagname.split(',')
        : [];

      this.confirmation = !tags.length;
      if (tags.includes(tag.tag)) {
        tags = this.removeFromArray(tags, tag.tag);
      } else {
        tags.push(tag.tag);
      }
      this.selectedTag = this.$route.params.tagname = tags.join(',');

      if (!this.confirmation) {
        this.viewProjectTagArchives();
      }
    },
    closeDialog() {
      this.confirmation = false;
    },
    tagAndCount(tag) {
      return '#' + tag.tag + '(' + tag.count + ')';
    },
    viewProjectTagArchives() {
      this.confirmation = false;
      let targetPath = `/discovery/projects/${this.$route.params.projectId}/archives/tags/${this.selectedTag}`;
      if (this.$route.path === targetPath) {
        return;
      }
      this.$router.push({
        path: targetPath,
      });
    },
  },
};
</script>
